import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { alpha, Box, Button, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { Icon } from '@iconify/react';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { getEventLanguagesByEventIdAsync } from '@application/features/languages/languagesThunk';
const TranslationsTab = () => {
    const theme = useTheme();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { eventId } = useParams();
    const dispatch = useAppDispatch();
    const { eventLanguages } = useAppSelector((state) => state.languages);
    useEffect(() => {
        if (eventId) {
            dispatch(getEventLanguagesByEventIdAsync(eventId));
        }
    }, [dispatch, eventId]);
    const handlePreview = (languageId) => {
        if (eventId) {
            const params = new URLSearchParams();
            params.set('eventId', eventId);
            // go directly to first step
            params.set('step', '1');
            if (languageId)
                params.set('languageId', languageId);
            navigate(`/create-event?${params.toString()}`);
        }
    };
    return (_jsx(Box, { children: _jsxs(Box, { sx: { display: 'flex', flexDirection: 'column', gap: 1.5 }, children: [_jsxs(Box, { sx: {
                        px: 1,
                        py: '6px',
                        minHeight: '50px',
                        borderRadius: 1.75,
                        backgroundColor: alpha(theme.palette.info.main, 0.08),
                        border: `1px solid ${alpha(theme.palette.info.main, 0.16)}`,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1.5
                    }, children: [_jsx(Icon, { icon: 'eva:info-fill', color: theme.palette.primary.main, fontSize: 24 }), _jsx(Typography, { variant: 'body2', sx: { color: theme.palette.info.dark }, children: t('events.eventDetails.translationsTab.autoSaveInfo') })] }), _jsx(Box, { sx: {
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 1.5
                    }, children: (eventLanguages || []).map((language, index) => (_jsxs(Box, { sx: {
                            borderRadius: 3,
                            border: `1px solid #919EAB52`,
                            overflow: 'hidden',
                            p: 2,
                            px: 2.5,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            gap: 2
                        }, children: [_jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: 2 }, children: [_jsx(Box, { component: 'img', src: language.flagUrl || '', alt: language.name, sx: {
                                            width: 32,
                                            height: 32,
                                            borderRadius: '4px',
                                            objectFit: 'cover'
                                        } }), _jsx(Typography, { variant: 'body1', children: language.name })] }), _jsx(Button, { variant: 'outlined', size: 'medium', onClick: () => handlePreview(language.id), color: 'primary', endIcon: _jsx(Icon, { icon: 'eva:arrow-forward-fill' }), children: t('actions.preview') || 'Preview' })] }, language.id))) })] }) }));
};
export default TranslationsTab;
